export const MAX_ADDITIONAL_PRODUCTS_DISPLAY = 230
